<template>
  <div>
    <v-dialog v-model="deactivateDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Deactivate Card</v-card-title>
        <v-card-text>
          <p class="text-subtitle-1">
            If you continue, this Card and its linked Connections will be
            deactivated. You can reactivate this card at any time.
          </p>
          <p class="text-subtitle-1">
            The team member will be notified inside their Pappyon app, that they
            no longer have access to this Card and will have a 48-hour timeframe
            to confirm whether they wish to retain access to their connections.
          </p>
          <v-btn
            class="mt-10 text-body-1"
            large
            elevation="0"
            color="primary"
            block
            @click="deactivateCardholder"
          >
            Deactivate Card
          </v-btn>

          <v-btn
            class="mt-2 text-body-1"
            large
            text
            elevation="0"
            color="primary"
            block
            @click="handleCancel"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <LoadingDialog
      :show="showLoadingDialog"
      title="Deactivating business card..."
    />
  </div>
</template>

<script>
import LoadingDialog from "@/components/LoadingDialog";
import { mapActions } from "vuex";
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
  props: {
    show: { type: Boolean, default: false },
    businessCard: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    LoadingDialog,
  },
  data() {
    return {
      deactivateDialog: false,
      showLoadingDialog: false,
    };
  },
  watch: {
    show: function (newValue) {
      this.deactivateDialog = newValue;
    },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    async deactivateCardholder() {
      try {
        this.deactivateDialog = false;
        this.$emit("close");
        //Start: Call a cloud function to deactivate to the selected card
        this.loadingMessage = `Deactivating business card...`;
        this.showLoadingDialog = true;
        const deactivateBusinessCard = getHttpsCallable("deactivateBusinessCard");
        let result = await deactivateBusinessCard({
          businessCardId: this.businessCard.id,
          businessProfileId: this.businessCard.businessProfileId,
          isDeactivatedByBusiness: true,
        });
        //The cloud function was executed
        if (result.data.errorInfo) {
          //Encountered an error
          console.log("In the client deactivateBusinessCard then error block");
          console.log("Error: " + result.data.errorInfo.message);
          this.showLoadingDialog = false;
        } else {
          console.log(result.data);
          this.showLoadingDialog = false;

          this.showSnackbar({
            show: true,
            text: "Team Member Deactivated Successfully!",
          });
        }
        //End: Call a cloud function to deactivate to the selected card
      } catch (error) {
        console.log(error);
      }
    },
    handleCancel() {
      this.deactivateDialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>